import { render, staticRenderFns } from "./AccountBalances.vue?vue&type=template&id=69c9043a&scoped=true&"
import script from "./AccountBalances.vue?vue&type=script&lang=ts&"
export * from "./AccountBalances.vue?vue&type=script&lang=ts&"
import style0 from "./AccountBalances.vue?vue&type=style&index=0&id=69c9043a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69c9043a",
  null
  
)

export default component.exports